<template>
  <div
    class="v-checkbox"
    :class="{
      [classType]: true,
      [extraClass]: !!extraClass,
      ['checked-wrapper']: checked
    }"
  >
    <div class="label-area">
      <label v-if="label" class="v-checkbox__label" @click="onChange">{{
        label
      }}</label>
      <label>
        <input
          type="checkbox"
          name="useAccountAddress"
          :class="{ ['checked']: checked }"
          :value="checked"
          @click="onChange"
        />
        <span data-icon="far fa-check" class="v-checkbox__box"></span>
      </label>

      <VHint
        v-if="hintProps || hint"
        v-bind="hintProps"
        :text="hintProps.text || hint"
        position="down"
        extraClass="checkbox-input-hint"
      ></VHint>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import arrow from "@/assets/images/arrow.svg";

import VHint from "@/components/VHint";

export default Vue.component("VCheckbox", {
  props: {
    name: VueTypes.string.isRequired,
    checked: VueTypes.bool.def(false),
    label: VueTypes.string,
    connectedWith: VueTypes.string,
    classType: VueTypes.oneOf(["primary", "secondary", "tertiary", "dark"]).def(
      "primary"
    ),
    extraClass: VueTypes.string,

    // text to display next to checkbox as a hint
    hint: VueTypes.string,
    innerChildProps: VueTypes.object
  },

  components: {
    VHint
  },

  data() {
    return {
      arrow
    };
  },

  computed: {
    hintProps() {
      return this.innerChildProps["hint"];
    }
  },

  methods: {
    onChange() {
      this.$emit("change", !this.checked);
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-";

/deep/ .checkbox-input-hint {
  margin-left: 15px;

  span::after {
    color: $secondary-text-color;
    font-family: Lato-Regular, Arial, sans-serif;
    font-size: 14px;
    line-height: 161%;
    display: inline-block;
    text-align: left;
    width: 200px;
    padding: 20px 15px;
    margin-bottom: 20px;
  }
}

.#{$ns}checkbox {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  padding-left: 20px;
  font-size: 0.875rem;
  line-height: 1.2;
  margin-right: 12px;
  color: #131e2c;

  .label-area {
    display: flex;
    align-items: center;
  }

  &__label {
    font-size: 14px;
    margin-left: 10px;
    color: #b4b2b2;
    transition: all 0.25s linear;
    cursor: pointer;
  }

  &.checked-wrapper {
    .v-checkbox__label {
      color: $primary-text-color;
    }
  }

  input[type="checkbox"] {
    display: none;

    &.checked + .#{$ns}checkbox__box {
      &:before {
        transform: scale(0.7);
        color: $white;
      }
    }
  }
  .#{$ns}checkbox__box {
    &:before,
    &:after {
      content: "";
      display: inline-block;
      width: 18px;
      height: 18px;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      z-index: 0;
    }
    &:before {
      font-family: "Font Awesome 5 Pro", sans-serif;
      content: "\f00c";
      font-size: 1.125rem;
      transform: scale(0);
      line-height: 1;
      z-index: 1;
      padding-left: 2px;
    }
    &:after {
      border: 1px solid #ebeef1;
      border-radius: 4px;
      transition: all 0.25s linear;
      cursor: pointer;
    }
  }

  &:hover {
    .v-checkbox__box::after {
      border: 1px solid $primary-color;
    }
    label {
      color: $main-text-color;
    }
  }
}

.primary {
  input[type="checkbox"] {
    &.checked + .#{$ns}checkbox__box {
      &:after {
        border-color: $primary-color;
        background-color: $primary-color;
      }
    }
  }
}

.secondary {
  input[type="checkbox"] {
    &.checked + .#{$ns}checkbox__box {
      &:after {
        border-color: $secondary-color;
        background-color: $secondary-color;
      }
    }
  }
}

.tertiary {
  input[type="checkbox"] {
    &.checked + .#{$ns}checkbox__box {
      &:after {
        border-color: $tertiary-color;
        background-color: $tertiary-color;
      }
    }
  }
}

.dark {
  input[type="checkbox"] {
    &.checked + .#{$ns}checkbox__box {
      &:after {
        border-color: #ebeef1;
      }

      &:before {
        color: #7c8ca3;
      }
    }
  }
}
</style>
